import React from "react";
import Logo from "assets/images/circularLCA_logo-new.svg";
import LogoOne from "assets/images/one_logo.svg";
import CombinedLogo from "assets/images/concular-combined-logo.svg";
import CircularAssetIcon from "assets/images/logo_circular_asset.png";
import { IS_CONCULAR_ONE, IS_CIRCULAR_ASSET, classNames } from "utils";
import BuildingHeader from "features/Building/BuildingHeader";
import { MenuIcon } from "@heroicons/react/solid";
import { useNavigate } from "react-router";
import { globalStore } from "store/GlobalStore";
import { observer } from "mobx-react-lite";
import { sidebarMenuStore } from "features/SidebarMenu/SidebarMenuStore";
import { LicenseAppType } from "api-client";

const Header = ({
  toggleSidebar,
  headerTitle,
}: {
  toggleSidebar: () => void;
  headerTitle?: React.ReactNode;
}) => {
  const navigate = useNavigate();

  if (IS_CONCULAR_ONE)
    return (
      <div
        className={`${
          !globalStore.sidebarOpened ? "visible" : "hidden"
        } flex items-center absolute px-4 py-[13px]`}
      >
        <img
          src={LogoOne}
          alt="Concular"
          className="h-6 w-auto cursor-pointer"
          onClick={() => navigate("/")}
        />
        <div
          id="menuToggler"
          className="h-full w-[30px] min-w-[30px] cursor-pointer flex justify-center"
          test-id="menu_toggler"
        >
          <MenuIcon
            onClick={toggleSidebar}
            className=" text-gray-500 h-full rounded p-[6px] hover:text-gray-900"
          />
        </div>
      </div>
    );

  const assetLicense =
    sidebarMenuStore.getCurrentLicense() === LicenseAppType.Asset;

  let renderLogo = IS_CIRCULAR_ASSET || assetLicense ? CircularAssetIcon : Logo;

  if (sidebarMenuStore.getCurrentLicense() === LicenseAppType.Manufacturer) {
    renderLogo = CombinedLogo;
  }

  return (
    <header
      className={classNames(
        "h-12 md:h-16 text-black !bg-white items-center border-b shadow-sm",
        "border-b-gray-300 w-full z-20 top-0 sticky flex print:hidden"
      )}
    >
      <div
        className={`${
          !globalStore.sidebarOpened ? "visible" : "hidden"
        } flex items-center h-full`}
      >
        <div
          id="menuToggler"
          className="h-full w-[64px] min-w-[64px] cursor-pointer flex justify-center border-r border-r-gray-300"
          test-id="menu_toggler"
        >
          <MenuIcon
            width={24}
            onClick={toggleSidebar}
            className="text-gray-500 h-full w-full hover:bg-gray-100 rounded md:p-[20px] p-[12px]"
          />
        </div>
        <div className="h-10 logo-wrapper cursor-pointer ml-6 hidden md:flex items-center border-r pr-4">
          <img
            className="min-h-[24px] min-w-[140px] max-h-[24px]"
            src={renderLogo}
            height={24}
            width={140}
            alt="Concular"
            onClick={() => navigate("/")}
          />
        </div>
      </div>
      {headerTitle ? (
        <div className="text-lg md:text-base font-semibold leading-7 px-6">
          {headerTitle}
        </div>
      ) : (
        <BuildingHeader />
      )}
    </header>
  );
};

export default observer(Header);
